import { createAsyncAction, createStandardAction } from 'typesafe-actions';
import { IUploadProgress } from '../../../api/mediaPlatform/types';
import { MediaType } from '../../../types/media';
import { UploadErrorType } from './types';

const upload = createAsyncAction(
  'MEDIA/UPLOAD/REQUEST',
  'MEDIA/UPLOAD/SUCCESS',
  'MEDIA/UPLOAD/FAIL',
)<
  { name: string; url: string; type: MediaType; selected: boolean },
  { name: string; url: string; type: MediaType },
  { name: string; error: UploadErrorType; selected: boolean }
>();

const progress = createStandardAction('MEDIA/UPLOAD/PROGRESS')<{
  name: string;
  progress: IUploadProgress;
}>();

const toggleSelected = createStandardAction('MEDIA/UPLOAD/TOGGLE_SELECTED')<{
  name: string;
  selected: boolean;
}>();

const clanUpFailed = createStandardAction('MEDIA/UPLOAD/CLAN_UP_FAILED')();

const setPreviewImage = createStandardAction('MEDIA/UPLOAD/SET_PREVIEW_IMAGE')<{
  url: string;
  name: string;
}>();

export { upload, progress, toggleSelected, clanUpFailed, setPreviewImage };
